import NoResults from "./NoResults";
import TextNotAnnotatedByGroup from "./TextNotAnnotatedByGroup";
import TextNotAnnotatedByMe from "./TextNotAnnotatedByMe";
import NoOrphanedAnnotations from "./NoOrphanedAnnotations";

export default {
  NoResults,
  TextNotAnnotatedByGroup,
  TextNotAnnotatedByMe,
  NoOrphanedAnnotations
};
